import { z } from 'zod';

export enum TemplateType {
  UNIT = 'UNIT',
  SCRIPT = 'SCRIPT',
}

const TemplateSchema = z.object({
  id: z.string(),
  name: z.string(),
  type: z.nativeEnum(TemplateType),
});

export const TemplateResponseSchema = z.array(TemplateSchema);

export type TemplateResponse = z.infer<typeof TemplateResponseSchema>;
export type Template = z.infer<typeof TemplateSchema>;
